<template>
  <div class="block-counteroffer">
    <div class="block-counteroffer__container">
      <div class="block-counteroffer__title">
        ЕСТЬ ПРЕДЛОЖЕНИЕ<br />
        ОТ КОНКУРЕНТОВ?
      </div>
      <div class="block-counteroffer__comment">СРАВНИТЕ ЕГО С НАШИМ!</div>
      <callback-input
        @phoneError="$emit('phoneError')"
        @callBack="(data) => this.$emit('callBack', data)"
        :form_class="'counteroffer'"
        :data="{ type: 'sale', form: 'contacts' }"
        :horizontal="false"
      >
        Получить предложение
      </callback-input>
      <block-contacts />
    </div>
  </div>
</template>

<script>
import BlockContacts from "./block-contacts";
import CallbackInput from "./callback-form/callback-input";

export default {
  components: {
    BlockContacts,
    CallbackInput,
  },
};
</script>

<style lang="scss" scoped>
.block-counteroffer {
  background: url("../img/background/pajero.jpg") no-repeat center;
  // background-color: #000;
  padding: 50px 0 50px;

  @media (max-width: 767px) {
    // background-color: #fff;
    padding: 4vw 0;
    background-size: 200%;
    background-position: 85% 175px;
  }

  @media (max-width: 380px) {
    background-position: 85% 165px;
  }

  @media (max-width: 320px) {
    background-position: 85% 120px;
  }

  &__container {
    margin: 0;
    max-width: 1140px;
    position: relative;
    padding: 0px 15px;
    @media (min-width: 1920px) {
      max-width: 1920px;
      margin: 0 auto;
    }
    @media (min-width: 767px) {
      text-align: left;
    }
  }

  @media (min-width: 767px) {
    .callback-form {
      align-items: flex-start;
      max-width: 450px;
      .input-block {
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }

  &__title {
    font-size: 55px;
    color: #fff;
    text-transform: uppercase;
    font-weight: 500;

    @media (max-width: 767px) {
      font-size: 36px;
      color: #000;
      font-weight: 600;
    }

    @media (max-width: 380px) {
      font-size: 32px;
      font-weight: 600;
    }

    @media (max-width: 360px) {
      font-size: 30px;
    }

    @media (max-width: 320px) {
      font-size: 28px;
    }
  }

  &__comment {
    font-size: 30px;
    color: white;
    text-transform: uppercase;
    font-weight: 500;
    margin-top: 60px;

    @media (max-width: 767px) {
      font-weight: 600;
      margin-top: 90vw;
      color: black;
    }

    @media (max-width: 560px) {
      margin-top: 100vw;
    }
  }
}

form .form-group {
  margin-bottom: 11px;
  position: relative;
}

form .form-group input[type="text"],
form select {
  height: 42px;
  width: 100%;
  border: 1px solid #a1a1a1;
  padding: 0px 40px;
  color: black;
  font-size: 16px;
  padding-left: 26px;
  font-weight: 400;
  box-sizing: border-box;
  outline: none;
  background: white;
  text-align: center;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
}

form .form-group button {
  width: 100%;
  outline: none;
  cursor: pointer;
  font-size: 14px;
  height: 52px;
}

#form1 {
  width: 610px;
  padding-top: 30px;

  @media (max-width: 767px) {
    width: 100%;
    padding-top: 10px;
  }

  input[type="tel"] {
    width: 100%;
    padding: 0 40px;

    background: transparent;
    color: white;
    border-color: white;
    height: 46px;

    @media (max-width: 767px) {
      color: black;
      border-color: black;
    }
  }

  .form-group_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media (max-width: 767px) {
      flex-wrap: wrap;
    }
  }

  .form-group {
    width: 48%;

    @media (max-width: 767px) {
      width: 100%;
    }

    button {
      height: 46px;
    }
  }

  .agree_field {
    color: white;
    padding-top: 0;

    @media (max-width: 767px) {
      color: black;
    }

    a {
      color: white;
      border-bottom: 1px dashed white;

      @media (max-width: 767px) {
        color: black;
        border-bottom: 1px dashed black;
      }
    }
  }
}

.agree_field {
  display: block;
  align-items: center;
  padding: 10px 0px;
  font-size: 12px;
  width: 100%;
  text-align: left;
  color: black;
  display: flex;
  justify-content: center;

  input {
    margin-right: 10px !important;
    vertical-align: middle !important;
    height: 14px !important;
    margin-top: 1px !important;
    margin: 0px;
  }

  a {
    color: black;
    border-bottom: 1px dashed black;
    text-decoration: none;
    margin-right: 4px;
    margin-left: 4px;
  }
}
</style>
